import routerConfig from "srs.sharedcomponents/lib/esm/components/config/routes";

const routesConfig = {...routerConfig}

export default routesConfig;
